<template>
  <div class="col-md-6 offset-md-3 mt-5 mb-5 formBlock">
    <MenssageAlert :messages="messages" />
    <h2 class="formTitle mt-1 mb-5">{{ $t('manageplan.contactForm.form.title') }}</h2>
    <CCol sm="12">
      <CInput
        class="mb-0 inputContactForm"
        :maxlength="30"
        :label="$t('manageplan.contactForm.form.fullName')"
        addLabelClasses="mt-1 required"
        :value.sync="$v.contactForm.fullName.$model"
        :isValid="!$v.contactForm.fullName.$anyError"
        :invalidFeedback="$t('faqs.contactUs.form.validation.requiredFieldText')"
      />
    </CCol>
    <CCol sm="12" class="mt-3">
      <CInput
        class="mb-0 inputContactForm"
        :maxlength="30"
        :label="$t('manageplan.contactForm.form.email')"
        addLabelClasses="mt-1 required"
        :value.sync="$v.contactForm.emailAddress.$model"
        :isValid="!$v.contactForm.emailAddress.$anyError"
        :invalidFeedback="
          !$v.contactForm.emailAddress.required
            ? $t('faqs.contactUs.form.validation.requiredFieldText')
            : !$v.contactForm.emailAddress.email
            ? $t('faqs.contactUs.form.validation.emailField')
            : $t('faqs.contactUs.form.validation.requiredFieldText')
        "
      />
    </CCol>
    <CCol sm="12" class="mt-3">
      <CInput
        class="mb-0 inputContactForm"
        :maxlength="30"
        :label="$t('manageplan.contactForm.form.companyName')"
        addLabelClasses="mt-1 required"
        :value.sync="$v.contactForm.companyName.$model"
        :isValid="!$v.contactForm.companyName.$anyError"
        :invalidFeedback="$t('faqs.contactUs.form.validation.requiredFieldText')"
      />
    </CCol>
    <CCol sm="12" class="mt-3">
      <CInput
        class="mb-0 inputContactForm"
        :maxlength="30"
        :label="$t('manageplan.contactForm.form.phoneNumber')"
        addLabelClasses="mt-1 required"
        :value.sync="$v.contactForm.phoneNumber.$model"
        :isValid="!$v.contactForm.phoneNumber.$anyError"
        :invalidFeedback="
          !$v.contactForm.phoneNumber.required
            ? $t('faqs.contactUs.form.validation.requiredFieldText')
            : !$v.contactForm.phoneNumber.numeric
            ? $t('faqs.contactUs.form.validation.numericFieldText')
            : $t('faqs.contactUs.form.validation.requiredFieldText')
        "
      />
    </CCol>
    <CCol sm="12" class="mt-3">
      <CInput
        class="mb-0 inputContactForm"
        @keyup="updateValueNumberContacts"
        :min="0"
        :label="$t('manageplan.contactForm.form.numberOfContacts')"
        addLabelClasses="mt-1 required"
        v-model="contactForm.numberOfContacts"
        type="number"
      />
    </CCol>
    <CRow class="canWeContact">
      <CCol sm="12" class="">
        <span class="canCallAboutServices">{{ $t('manageplan.contactForm.form.canCallAboutServices') }}</span>
      </CCol>
      <CCol sm="12" class="mt-3">
        <!-- <CInputRadio
          :label="$t('manageplan.contactForm.form.yes')"
          type="radio"
          :value="contactForm.yes"
          name="target"
          :checked="contactForm.canCallAboutServices"
          @change="updateCanCall(contactForm.yes)"
        /> -->
        <CInputRadioGroup :options="comunicationOptions" :checked.sync="contactForm.comunicationPermission" />
      </CCol>
      <!-- <CCol sm="2" class="mt-3">
        <CInputRadio
          :label="$t('manageplan.contactForm.form.no')"
          type="radio"
          :value="contactForm.no"
          name="target"
          class=""
          :checked="!contactForm.canCallAboutServices"
          @change="updateCanCall(contactForm.no)"
        />
      </CCol> -->
    </CRow>
    <CCol sm="12" class="mt-3">
      <CButton color="primary" :disabled="loading" class="w-100" @click="submitContact()">
        {{ $t('manageplan.contactForm.form.action') }}
        <!-- <CSpinner v-if="isLoadingSend" color="primary" class="ml-3" style="width: 1.5rem; height: 1.5rem" /> -->
      </CButton>
    </CCol>
  </div>
</template>

<script>
import services from '@/services.js'
import MenssageAlert from '@/components/MenssageAlert'
import { validationMixin } from 'vuelidate'
import { required, email, numeric } from 'vuelidate/lib/validators'

export default {
  name: 'ContactForm',
  components: { MenssageAlert },

  mixins: [validationMixin],

  validations: {
    contactForm: {
      fullName: {
        required,
      },
      emailAddress: {
        required,
        email,
      },
      companyName: {
        required,
      },
      phoneNumber: {
        required,
        numeric,
      },
      subject: {
        required,
      },
    },
  },

  data() {
    return {
      message: 'suporte.comercial@sendit.pt', // TODO: Não sei qual é a melhor abordagem pra esse email. O ideal é que fosse uma configuração do backend
      isLoadingSend: false,
      comunicationOptions: [
        { label: this.$t('manageplan.contactForm.form.yes'), value: 'YES' },
        { label: this.$t('manageplan.contactForm.form.no'), value: 'NO' },
      ],
      contactForm: {
        fullName: '',
        emailAddress: '',
        companyName: '',
        phoneNumber: '',
        numberOfContacts: null,
        canCallAboutServices: true,
        comunicationPermission: 'YES',
        // yes: true,
        // no: false,
      },
      messages: [],
    }
  },
  computed: {
    hasContactInfo() {
      return (
        this.contactForm.fullName &&
        this.contactForm.email &&
        this.contactForm.companyName &&
        this.contactForm.phoneNumber &&
        this.contactForm.numberOfContacts
      )
    },
  },
  methods: {
    updateCanCall(value) {
      this.contactForm.canCallAboutServices = value
    },
    updateValueNumberContacts(t) {
      this.contactForm.numberOfContacts = parseInt(this.contactForm.numberOfContacts)
      if (this.contactForm.numberOfContacts < 0) {
        this.contactForm.numberOfContacts = 0
      }
    },
    submitContact() {
      this.$v.$touch()

      if (this.$v.$anyError) return

      this.isLoadingSend = true
      this.messages = []
      let organizationId = this.$route.params.organizationId
      let emailContent = '- organizationId: ' + organizationId + '\n'
      for (var i in this.contactForm) {
        emailContent += `- ${i}: ${this.contactForm[i]}\n`
      }

      let requestBody = {
        // TODO: Remover este valor - O frontend não tem como saber essa informação, portanto estou adicionando apenas para fins de teste. Embora não acho que ela deveria ter influencia nesse contexto
        senderUserId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
        senderEmail: this.email,
        email: {
          message: emailContent.replace('{', '').replace('}', ''),
          subject: 'Plataforma Arpoone - Planos - Novo Pedido de Informação',
          cc: [],
        },
      }

      services
        .postSalesManagerContact(organizationId, requestBody)
        .then(() => {
          this.messages.push({
            status: 'success',
            text: this.$t('faq.contacat.success.messaage'),
          })

          setTimeout(() => {
            this.$emit('sentSuccessfully')
          }, 2000)
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message,
          })
        })
        .finally(() => (this.isLoadingSend = false))
    },
  },
}
</script>

<style lang="scss">
.formBlock {
  background-color: #fff;
  padding: 50px 35px;
}

.inputContactForm input {
  border: 1px solid #dee2e6 !important;
}

.formTitle {
  font-size: 24px;
  color: #343a40;
  text-align: center;
}

.canWeContact {
  padding: 20px;
}

.canCallAboutServices {
  font-weight: 600;
  font-size: 1rem;
}

.btnSend {
  background-color: #403266;
  border-radius: 5px;
  color: #fff;
  width: 100%;
  height: 50px;
  border: 1px solid #403266;
}
</style>
